import styled from 'styled-components';

export const PopoverMenu = styled.div`
  min-width: 200px;
  z-index: 1000;
  top: 20px;
  right: 0;
  background-color: var(--dropdown-background-color);
`;
